"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _selectProducts = _interopRequireDefault(require("../../business/supplier/coupons/selectProducts.vue"));
var _bindChannel = _interopRequireDefault(require("./bindChannel.vue"));
var _rsManagement = require("@/api/rsManagement");
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
var _rsApi = require("@/api/rsApi");
var _fudouActiveApi = require("@/api/fudouActiveApi");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectProducts: _selectProducts.default,
    BindChannel: _bindChannel.default
  },
  data: function data() {
    return {
      initDetail: {},
      // 搜索表单数据
      pageFrom: {
        page: 1,
        limit: 20,
        keywords: '',
        supplierId: '',
        storeStatus: '',
        businessStatus: '',
        regionId: [],
        storeType: '',
        wmTgFlag: []
      },
      // 表格数据
      tableData: {
        list: [],
        total: 0
      },
      isAllSelected: false,
      selectedList: [],
      selectedMap: new Map(),
      // 跨页选中缓存
      syncingSelection: false,
      loading: false,
      // 店铺表单弹窗相关
      storeFormVisible: false,
      isEditMode: false,
      currentStoreData: {},
      currentStoreId: null,
      // 商户选项
      merchantOptions: [],
      filteredMerchantOptions: [],
      merchantLoading: false,
      searchTimer: null,
      // 地区选项
      areaOptions: [],
      // 店铺类型选项（来自数据字典 ykt_industry_type）
      storeTypeOptions: [],
      wmTgFlagOptions: [{
        value: '1',
        label: '实物',
        type: 'success'
      }, {
        value: '2',
        label: '团购',
        type: 'success'
      }, {
        value: '3',
        label: '酒店',
        type: 'success'
      }]
    };
  },
  created: function created() {
    // 先初始化数据，再获取列表
    this.initData();
    this.loadStoreTypeOptions();
    this.getList();
  },
  props: {
    show: {
      // 父组件传入的显示控制
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show'],
  computed: {
    visible: {
      get: function get() {
        return this.show;
      },
      set: function set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  watch: {
    'tableData.list': {
      immediate: true,
      handler: function handler(list) {
        var _this = this;
        if (!list || !list.length) return;
        this.syncingSelection = true;
        this.$nextTick(function () {
          var table = _this.$refs.table;
          console.log(table);
          if (!table) return;
          // 先清空
          table.clearSelection();
          list.forEach(function (row) {
            if (_this.selectedMap.has(row.id) || _this.isAllSelected) {
              table.toggleRowSelection(row, true);
            }
          });
          _this.syncingSelection = false;
        });
      }
    }
  },
  /*   watch: {
      'tableData.list'(list) {
        if (!list || !list.length) return
  
        this.$nextTick(() => {
          const table = this.$refs.table
          if (!table) return
  
          this.syncingSelection = true
          table.clearSelection()
  
          list.forEach(row => {
            if (this.selectedMap.has(row.id) || this.isAllSelected) {
              table.toggleRowSelection(row, true)
            }
          })
  
          this.syncingSelection = false
        })
      }
    }, */
  methods: {
    // 获取列表数据
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      var reqData = JSON.parse(JSON.stringify(this.pageFrom));

      // 处理地区ID，取最后一个值
      if (reqData.regionId && reqData.regionId.length > 0) {
        reqData.regionId = reqData.regionId[reqData.regionId.length - 1];
      } else {
        reqData.regionId = '';
      }
      if (Array.isArray(reqData.wmTgFlag)) {
        reqData.wmTgFlag = reqData.wmTgFlag.join(',');
      }
      reqData.channelId = this.initDetail.id;
      try {
        (0, _fudouActiveApi.bindStoreList)(reqData).then(function (res) {
          if (res) {
            // 初始化 selectedMap
            if (!_this2.isAllSelected) {
              res.list.forEach(function (row) {
                if (row.isSelect) {
                  _this2.selectedMap.set(row.id, row);
                }
              });
            }
            _this2.tableData.list = res.list || [];
            _this2.tableData.total = res.total || 0;
          }
        });
      } catch (error) {
        console.error('获取店铺列表失败：', error);
        this.$message.error('获取数据失败：' + (error.message || '未知错误'));
        this.tableData.list = [];
        this.tableData.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 打开
    initOpen: function initOpen(row) {
      this.initDetail = row || {};
      this.selectedMap.clear();
      this.isAllSelected = row.isAllMerchantStore;
      this.handleAllChange(row.isAllMerchantStore);
      this.initData();
      this.loadStoreTypeOptions();
      this.getList();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    closeDrawer: function closeDrawer() {
      this.$emit('doRefresh');
    },
    // 初始化数据
    initData: function initData() {
      // 获取商户列表、地区数据等
      this.getMerchantList();
      this.getAreaData();
      this.getStoreTypeOptions();
    },
    // 加载店铺类型（字典：ykt_industry_type）
    loadStoreTypeOptions: function loadStoreTypeOptions() {
      var _this3 = this;
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/rsApi'));
      }).then(function (_ref) {
        var getStoreTypeOptions = _ref.getStoreTypeOptions;
        getStoreTypeOptions().then(function (res) {
          _this3.storeTypeOptions = res || [];
        }).catch(function () {
          _this3.storeTypeOptions = [];
        });
      });
    },
    // 获取商户列表
    getMerchantList: function getMerchantList() {
      var _this4 = this;
      this.merchantLoading = true;
      try {
        (0, _rsManagement.getSupplierAutoList)().then(function (res) {
          if (res && Array.isArray(res)) {
            _this4.merchantOptions = res.map(function (item) {
              return {
                value: Number(item.id || item.supplierId),
                label: item.supplierName || item.name
              };
            });
            _this4.filteredMerchantOptions = _toConsumableArray(_this4.merchantOptions);
          }
        });
      } catch (err) {
        console.error('获取商户列表失败：', err);
        this.$message.error('获取商户列表失败');
      } finally {
        this.merchantLoading = false;
      }
    },
    // 获取地区数据
    getAreaData: function getAreaData() {
      var _this5 = this;
      dangaoActApi.getShopSelfAddress().then(function (res) {
        _this5.areaOptions = res || [];
      }).catch(function (err) {
        console.error('获取地区数据失败：', err);
        _this5.$message.error('获取地区数据失败');
      });
    },
    // 获取店铺类型选项
    getStoreTypeOptions: function getStoreTypeOptions() {
      var _this6 = this;
      (0, _rsApi.getStoreTypeOptions)().then(function (res) {
        if (res && res.length > 0) {
          // 数据已经在 rsApi.js 中处理过了，直接使用
          _this6.storeTypeOptions = res;
        } else {
          _this6.storeTypeOptions = [];
        }
      }).catch(function (err) {
        console.error('获取店铺类型选项失败:', err);
        // 如果获取失败，使用默认选项
        _this6.storeTypeOptions = [{
          value: '1',
          label: '商超'
        }, {
          value: '2',
          label: '蛋糕'
        }];
      });
    },
    clearMerchantList: function clearMerchantList() {
      this.$refs.table.clearSelection();
      this.isAllSelected = false;
    },
    getWmTgFlagList: function getWmTgFlagList(wmTgFlag) {
      var _this7 = this;
      if (wmTgFlag === null || wmTgFlag === undefined || wmTgFlag === '') {
        return [];
      }
      var values = Array.isArray(wmTgFlag) ? wmTgFlag : String(wmTgFlag).split(',');
      return values.map(function (item) {
        var option = _this7.wmTgFlagOptions.find(function (opt) {
          return opt.value === String(item).trim();
        });
        return option ? _objectSpread({}, option) : null;
      }).filter(Boolean);
    },
    save: function save() {
      var _this8 = this;
      var save = {
        channelId: this.initDetail.id,
        isAllMerchantStore: this.isAllSelected,
        storeInfo: []
      };
      var _iterator = _createForOfIteratorHelper(this.selectedMap.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          var tmpList = {};
          tmpList.merchantId = value.merchantId;
          tmpList.merchantStoreId = value.id;
          save.storeInfo.push(tmpList);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      (0, _fudouActiveApi.merchantStoreBind)(save).then(function (res) {
        _this8.$message.success('绑定成功');
        _this8.getList();
      }).catch(function (res) {
        _this8.$message.error(res.message);
      });
    },
    getRowKey: function getRowKey(row) {
      return row.id;
    },
    handleAllChange: function handleAllChange(val) {
      var _this9 = this;
      var table = this.$refs.table;
      if (table) {
        if (val) {
          this.selectedMap.clear(); // 精确选择清空
          this.$nextTick(function () {
            _this9.tableData.list.forEach(function (row) {
              table.toggleRowSelection(row, true);
            });
          });
        } else {
          table.clearSelection();
        }
      }
    },
    handleSelectionChange: function handleSelectionChange(currentPageSelection) {
      var _this0 = this;
      if (this.syncingSelection) return;
      if (this.isAllSelected) return;
      console.log("选择方法请求了");
      var pageIds = this.tableData.list.map(function (r) {
        return r.id;
      });
      var selectedIds = currentPageSelection.map(function (r) {
        return r.id;
      });

      // 取消当前页未选中的
      pageIds.forEach(function (id) {
        if (!selectedIds.includes(id)) {
          _this0.selectedMap.delete(id);
        }
      });

      // 保存当前页选中的
      currentPageSelection.forEach(function (row) {
        _this0.selectedMap.set(row.id, row);
      });
    },
    selectableRow: function selectableRow() {
      return !this.isAllSelected;
    }
  }
};